import { render, staticRenderFns } from "./labelsYunFee.vue?vue&type=template&id=792676de&"
import script from "./labelsYunFee.vue?vue&type=script&lang=js&"
export * from "./labelsYunFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports